import { ApexUIClassicProvider } from "@apex/component-library";
import React from "react";
import ReactDOM from "react-dom";
import { QueryClient } from "react-query";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { ReactQueryProvider } from "./contexts/react-query/ReactQueryContext";
import { AppRoutes } from "./routes";
import { startRum } from "./utils/datadog";

declare global {
  interface Window {
    Cypress: any;
  }
}

if (!window.Cypress) {
  startRum();
}

export const queryClient = new QueryClient();
// For local dev, redirect to base url
if (!window.location.pathname.includes(AppRoutes.Root)) {
  window.history.replaceState("", "", `${AppRoutes.Root}`);
}

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter basename={AppRoutes.Root}>
      <ApexUIClassicProvider>
        <ReactQueryProvider>
          <App />
        </ReactQueryProvider>
      </ApexUIClassicProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
